import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import styled from "styled-components";
import { SectionTop, Button } from "../../reusables";

export default function PrayerReqForm({
	buttonText,
	className,
	submitFunction,
}) {
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm();

	const onSubmit = async (data) => {
		const config = {
			method: "post",
			url: "https://3h.stemtutorsonline.info/prayer-requests/create/",
			headers: {
				"Content-Type": "application/json",
			},
			data: data,
		};
		// //TODO post email(data) to api
		try {
			const response = await axios(config);
			reset({
				first_name: "",
				last_name: "",
				phone: "",
				email: "",
				subject: "",
				request: "",
			});
			return response && toast.dark("Request Submitted!🎉");
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<FormWrapper>
			<SectionTop
				heading="Send your request using the form below"
				fullHeading
			/>

			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="top-form">
					<div>
						<label>First Name</label>
						<input
							type="text"
							{...register("first_name", { required: true })}
						/>
						{errors.first_name && (
							<span>This field is required</span>
						)}
					</div>

					<div>
						<label>Last Name</label>
						<input
							type="text"
							{...register("last_name", { required: true })}
						/>
						{errors.last_name && (
							<span>This field is required</span>
						)}
					</div>
				</div>

				<div className="input-container">
					<label>Phone</label>
					<input type="tel" {...register("phone")} />
				</div>

				<div className="input-container">
					<label>Email</label>
					<input
						type="email"
						{...register("email", { required: true })}
					/>
					{errors.email && <span>This field is required</span>}
				</div>

				<div className="input-container">
					<label>Subject</label>
					<input
						type="text"
						{...register("subject", { required: true })}
					/>
					{errors.subject && <span>This field is required</span>}
				</div>

				<div className="input-container">
					<label>Request</label>
					<textarea
						type="text"
						{...register("request", { required: true })}
					/>
					{errors.request && <span>This field is required</span>}
				</div>

				<Button wide uppercase>
					Send Request
				</Button>
			</form>
		</FormWrapper>
	);
}

const FormWrapper = styled.section.attrs((props) => ({}))`
	/* h3 {
		margin-bottom: 2rem;
		text-align: center;
	} */

	form {
		width: 60%;
		margin: 0 auto;

		.top-form {
			display: flex;
			margin-bottom: 2rem;

			> * {
				flex: 1;

				&:first-child {
					margin-right: 1rem;
				}
			}
		}

		.top-form,
		.input-container {
			margin-bottom: 30px;

			label {
				display: block;
				margin-bottom: 12px;
				font-size: 14px;
			}

			input,
			textarea {
				width: 100%;
				height: 3rem;
				margin-bottom: 0.6rem;

				border: none;
				border-radius: 4px;
				background: #f1f1f1;

				font-size: 0.8rem;
			}

			textarea {
				min-height: 8rem;
			}

			span {
				color: red;
				font-size: 0.8rem;
			}
		}
	}

	@media (max-width: 768px) {
		h2 {
			width: 70% !important;
		}

		form {
			width: 100%;

			.top-form {
				flex-direction: column;

				> * {
					&:first-child {
						margin-right: 0;
						margin-bottom: 2rem;
					}
				}
			}
		}
	}
`;
